/* SafeGrip – varukorgen.

   Den här filen innehöll tidigare en egen version av updateQuantity som tog
   över plus, minus och papperskorgen. Den skapade fler problem än den löste
   (omladdad sida, vit ruta, tom varukorg) och är nu helt borttagen.

   Antalsknapparna, borttagningen och kassaknappen sköts därmed av temats egen
   kod, precis som Debutify byggde den. Lägg inte tillbaka någon överskrivning
   här utan att först kunna återskapa felet i en riktig webbläsare.

   Det enda som är kvar är en städning: rabattwidgeten sparar koden i
   localStorage och kör /discount/<kod> igen vid varje sidladdning. Är det
   sparade värdet tomt blir anropet /discount/ utan kod. */
(function () {
  try {
    var stored = localStorage.getItem('dbtfy-cart-discount');
    if (stored !== null && stored.trim() === '') {
      localStorage.removeItem('dbtfy-cart-discount');
    }
  } catch (e) {
    /* privat läge eller blockerade kakor – inget att göra */
  }
})();
